import styled from "styled-components";

export const TimeOrStationCodeBox = styled.div`
    font-size: ${props => props.theme.fontSize.huge3};
    font-weight: ${props => props.theme.fontWeight.semiBold};
`